import {createAsyncThunk} from '@reduxjs/toolkit';

import {TRequestTableResponseWithPagination} from 'shared/types/requests';
import {IRpcDeleteResponse} from 'shared/types/rpc';

import {
    IDeleteAisNotificationScenariosSettingsTableRowsParams,
    deleteAisNotificationScenariosSettingsTableRowsRequest,
    fetchAisNotificationScenariosServices,
    IFetchAisNotificationScenariosSettingsParams,
    fetchAisNotificationScenariosSettingsTable,
    postAisNotificationScenariosSetting,
    TPostAisNotificationScenariosSettingData,
    putAisNotificationScenariosSetting,
    TPutAisNotificationScenariosSettingData,
} from './ais-notification-scenarios-settings-api';
import {AIS3_SCENARIO_SETTINGS_API_PREFIX} from './ais-notification-scenarios-settings-constants';
import {IAisNotificationScenariosSettingsServices, IAisNotificationScenariosSettingsTableDto} from './ais-notification-scenarios-settings-types';

// ==== Thunks to work with Ais Notification Scenarios Settings Table ====
export const loadAisNotificationScenariosSettingsTable = createAsyncThunk<
    TRequestTableResponseWithPagination<IAisNotificationScenariosSettingsTableDto>,
    IFetchAisNotificationScenariosSettingsParams>(
        `${AIS3_SCENARIO_SETTINGS_API_PREFIX}/aisNotificationScenariosSettingsTable`,
        async (args, {rejectWithValue}) => {
            try {
                const response = await fetchAisNotificationScenariosSettingsTable(args);
                const {data} = response;
                return {dataTable: data.dataTable, recordsTotal: data.recordsTotal};
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );

export const deleteAisNotificationScenariosSettingsTableRows = createAsyncThunk<
    IRpcDeleteResponse,
    IDeleteAisNotificationScenariosSettingsTableRowsParams>(
        `${AIS3_SCENARIO_SETTINGS_API_PREFIX}/deleteAisNotificationScenariosSettingsTableRows`,
        async (args, {rejectWithValue}) => {
            try {
                const response = await deleteAisNotificationScenariosSettingsTableRowsRequest(args);
                const {data} = response;
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );

// ==== Thunks to work with Ais Notification Scenarios Settings Form ====
export const createAisNotificationScenariosSetting = createAsyncThunk<
    string,
    TPostAisNotificationScenariosSettingData>(
        `${AIS3_SCENARIO_SETTINGS_API_PREFIX}/createAisNotificationScenariosSetting`,
        async (args, {rejectWithValue}) => {
            try {
                const response = await postAisNotificationScenariosSetting(args);
                const {data} = response;
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );

export const updateAisNotificationScenariosSetting = createAsyncThunk<
    string,
    TPutAisNotificationScenariosSettingData>(
        `${AIS3_SCENARIO_SETTINGS_API_PREFIX}/updateAisNotificationScenariosSetting`,
        async (args, {rejectWithValue}) => {
            try {
                const response = await putAisNotificationScenariosSetting(args);
                const {data} = response;
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );

export const loadAisNotificationScenariosServices = createAsyncThunk<
    IAisNotificationScenariosSettingsServices[]>(
        `${AIS3_SCENARIO_SETTINGS_API_PREFIX}/aisNotificationScenariosSettingsServices`,
        async (_, {rejectWithValue}) => {
            try {
                const response = await fetchAisNotificationScenariosServices();
                const {data} = response;
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );
